export default "__VITE_ASSET__24b38a58__"